export const ROOT = '/';
export const TOKENS = '/tokens';
export const TOKENS_NEW = '/tokensNew';
export const LOGIN = '/login';
export const APP_LOGIN = '/appLogin';
